<template>
  <div class="account-container" :class="{ 'mobile-style': containerWidth <= 1100 }">
    <div class="account-header">
      <AccountIcon
        :accountStage="accountData.accountStage"
        :accountStatus="accountData.status"
        :accountNumber="accountData.sessionNumber"
      />
    </div>

    <div class="account-content payment_status">
      <!-- <div class="head">
        <div v-if="accountData.platform" class="platform-text">
          {{ accountData.platform }}
        </div>
        <div class="session-number-text">{{ accountData.sessionNumber }}</div>
      </div> -->
      <div class="body">
        <div class="body-main">
          <img
            :style="{ height: '24px', width: '24px' }"
            :src="require(`@/assets/images/flag/currency/${accountData.currency}.png`)"
            :alt="accountData.currency"
          />
          <div class="equity-area">
            <EquityNumber :value="accountData.equity" />
            <div class="currency-text">{{ accountData.currency }}</div>
          </div>
        </div>
        <div class="body-bottom">
          <div class="account-footer-detail-item">
            {{ statusDesc }} {{ accountData.statusDate }}
          </div>
          <div class="body-bottom-item" v-if="accountData.status !== null">
            <AccountStatus :accountStatus="accountData.status" type="paymentStatus" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountIcon from '@/components/propTrading/components/dashboard/AccountIcon.vue';
import EquityNumber from '@/components/propTrading/components/dashboard/EquityNumber.vue';
import AccountStatus from '@/components/propTrading/components/dashboard/AccountStatus.vue';
import splitThousands from '@/util/splitThousands';
import {
  SESSION_STATUS_REV,
  PAYMENT_STATUS,
  PAYMENT_STATUS_REV,
} from '@/constants/propTrade';

export default {
  name: 'DashboardPaymentStatus',
  props: {
    accountData: {
      type: Object,
      default: () => ({}),
    },
    containerWidth: {
      type: Number | String,
      default: 0,
    },
  },
  components: {
    AccountIcon,
    EquityNumber,
    AccountStatus,
  },
  data() {
    return {
      SESSION_STATUS_REV,
      PAYMENT_STATUS,
      PAYMENT_STATUS_REV,
      showHistory: false,
      historyData: [],
      resetPwdForm: {
        currentPwd: '',
        newPwd: '',
        confirmNewPwd: '',
      },
    };
  },
  computed: {
    statusDesc() {
      if (
        [
          PAYMENT_STATUS.SUBMITTED,
          PAYMENT_STATUS.EXPIRED,
          PAYMENT_STATUS.MISMATCHED,
        ].includes(this.accountData.status)
      ) {
        return `${this.$t('propTrade.dashboard.applicationTime')} : `;
      }

      if ([PAYMENT_STATUS.SUCCESS].includes(this.accountData.status)) {
        return `${this.$t('propTrade.dashboard.paymentTime')} : `;
      }

      if ([PAYMENT_STATUS.FAILED].includes(this.accountData.status)) {
        return `${this.$t('propTrade.dashboard.failedTime')} : `;
      }

      return '';
    },
    resetFormRules() {
      return {
        currentPwd: [
          {
            required: true,
            message: this.$t('common.formValidation.dynamicReq', {
              dynamic: this.$t('propTrade.resetPassword.currentPwd'),
            }),
            trigger: 'blur',
          },
        ],
        newPwd: [
          {
            required: true,
            message: this.$t('common.formValidation.dynamicReq', {
              dynamic: this.$t('propTrade.resetPassword.newPwd'),
            }),
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (
                this.resetPwdForm?.currentPwd &&
                value === this.resetPwdForm.currentPwd
              ) {
                callback(new Error(this.$t('propTrade.resetPassword.newPwdErrorMsg')));
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        confirmNewPwd: [
          {
            required: true,
            message: this.$t('common.formValidation.dynamicReq', {
              dynamic: this.$t('propTrade.resetPassword.confirmNewPwd'),
            }),
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (this.resetPwdForm?.newPwd && value !== this.resetPwdForm.newPwd) {
                callback(
                  new Error(this.$t('propTrade.resetPassword.confirmNewPwdErrorMsg'))
                );
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
      };
    },
  },
  mounted() {
    console.log('mounted_accountData', this.accountData)
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/propTrading/components/dashboard/account-or-payment-status.scss';
</style>
